// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.address-error[data-v-709e7807] { display: block; color: #d93025;\n}\n.address-error button[data-v-709e7807] { margin-left: 8px; border: 0; background: none; color: #1267a3; cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
